import { Button, Col, Row } from "antd";
import "./Order_Overview.css";
import React, { useContext, useEffect, useState } from "react";
import CheckoutStepFormContext from "../CheckoutStepFormContext";
import Light_Gray_Outline_Btn from "../../../common-components/common_btn/gray_outline_btn/Light_Gray_Outline_Btn";
import Green_Outline_Btn from "../../../common-components/common_btn/green_outline_btn/Green_Outline_Btn";
import Increment_decrement_btn_holder from "../../../common-components/common_btn/increment_decrement_btn_holder/Increment_decrement_btn_holder";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTags, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { Form, InputGroup, Modal, Table } from "react-bootstrap";
import Order_Overview_summery_holder from "./order_Overview_summery_holder/Order_Overview_summery_holder";
import { Link, useNavigate } from "react-router-dom";
import Green_btn from "../../../common-components/common_btn/green_btn/Green_btn";
import Success_Modal from "../../../common-components/common_modal/success_modal/Success_Modal";
import Coupons_Modal from "../../../common-components/common_modal/coupons_modal/Coupons_Modal";
import { useDispatch, useSelector } from "react-redux";
import { deleteAllCart, getAllCart } from "../../../../features/cart/cartSlice";
import {
  CouponApplyed,
  createOrder,
  getSingleOrderAddress,
  OrderCalculation,
} from "../../../../features/order/orderSlice";
import useRazorpay from "react-razorpay";
import { useForm } from "react-hook-form";
import Delete_Modal from "../../../common-components/common_modal/delete_modal/Delete_Modal";
import Spinner from "react-bootstrap/Spinner";
import { variant_type } from "../../../../utils/common";
import Orange_Btn from "../../../common-components/common_btn/orange_btn/Orange_Btn";

const Order_Overview = ({ paymentValue, selectedAddressId }) => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // use "auto" for instant scrolling
    });
  }, []);

  const [modalDeleteShow, setModalDeleteShow] = React.useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [showCouponModal, setShowCouponModal] = useState(false);

  const [data, setData] = useState({});
  const { prev } = useContext(CheckoutStepFormContext);
  const navigate = useNavigate();

  const handleClick = () => {
    setModalShow(true); // Show modal

    setTimeout(() => {
      setModalShow(false); // Close modal after 3s (optional)
      navigate("/"); // Navigate after modal
    }, 3000); // Show for 3 seconds
  };

  const currentCurrency = useSelector((state) => state.master.currentCurrency);
  const rate = Number(currentCurrency?.rate) || 1;
  const symbol = currentCurrency?.symbol || "$";

  const [CouponData, setCouponData] = React.useState("");
  const [couponError, setCouponError] = useState("");

  const [Errors, setErrors] = React.useState(null);
  const [loader, setLoader] = useState(false);

  const isSignin = useSelector((state) => state.auth.is_signin);
  const dispatch = useDispatch();
  const allcartData = useSelector((state) => state.cart.allCarts);
  useEffect(() => {
    dispatch(getAllCart(isSignin));
  }, [dispatch]);

  const orderCalculation = async (selectedAddressId, currentCurrency) => {
    setLoader(true);

    const data = {
      address_id: selectedAddressId,
      exchange_rate: currentCurrency?.rate,
    };

    if (CouponData) {
      data.coupon_id = CouponData?.id;
    }
    const res = await dispatch(OrderCalculation(data));

    if (res.meta?.requestStatus === "fulfilled") {
      setData(res.payload.data);
    } else if (res.meta?.requestStatus === "rejected") {
      if (res.payload?.errors) {
        setErrors(res.payload?.errors);
      }
    }
    await setLoader(false);
  };

  useEffect(() => {
    if (selectedAddressId) {
      orderCalculation(selectedAddressId, currentCurrency);
    }
  }, [selectedAddressId, CouponData?.id, currentCurrency?.id]);

  const getAppliedDiscount = (val) => {
    const orderDetails = data?.order_Details_summary;

    if (!Array.isArray(orderDetails)) {
      return null;
    }

    const matchedItem = orderDetails.find((item) => {
      return (
        Number(item?.product_id) === Number(val?.product_id) &&
        Number(item?.variant_id || 0) === Number(val?.variant_id || 0) &&
        Number(item?.d_variant_id || 0) === Number(val?.d_variant_id || 0) &&
        Number(item?.t_variant_id || 0) === Number(val?.t_variant_id || 0)
      );
    });

    if (!matchedItem || Number(matchedItem?.offer_discount || 0) <= 0) {
      return null;
    }

    return matchedItem;
  };

  // const getDiscountBadgeText = (discountItem) => {
  //   if (!discountItem) {
  //     return null;
  //   }

  //   const discountSource = discountItem?.discount_source;
  //   const offerDiscount = Number(discountItem?.offer_discount || 0);
  //   const totalSellingPrice = Number(discountItem?.total_selling_price || 0);

  //   if (discountSource === "buy_one_get_one") {
  //     if (
  //       offerDiscount > 0 &&
  //       totalSellingPrice > 0 &&
  //       offerDiscount >= totalSellingPrice
  //     ) {
  //       return "FREE";
  //     }

  //     if (offerDiscount > 0 && totalSellingPrice > 0) {
  //       const percentage = (offerDiscount / totalSellingPrice) * 100;

  //       return `${
  //         Number.isInteger(percentage) ? percentage : percentage.toFixed(2)
  //       }% OFF`;
  //     }

  //     return null;
  //   }

  //   switch (discountSource) {
  //     case "prod_discount":
  //       return "Product Discount";

  //     case "cat_discount":
  //       return "Category Discount";

  //     case "global_discount":
  //       return "Flat Discount";

  //     default:
  //       return null;
  //   }
  // };

  const getDiscountBadgeText = (discountItem) => {
    if (!discountItem) {
      return null;
    }

    const discountSource = discountItem?.discount_source;
    const offerDiscount = Number(discountItem?.offer_discount || 0);
    const totalSellingPrice = Number(discountItem?.total_selling_price || 0);

    if (discountSource === "buy_one_get_one") {
      // Full discount = FREE
      if (
        offerDiscount > 0 &&
        totalSellingPrice > 0 &&
        offerDiscount >= totalSellingPrice
      ) {
        return "FREE";
      }

      // Partial discount = show exact percentage
      if (offerDiscount > 0 && totalSellingPrice > 0) {
        const percentage = (offerDiscount / totalSellingPrice) * 100;

        return `${
          Number.isInteger(percentage) ? percentage : percentage.toFixed(2)
        }% OFF`;
      }

      return null;
    }

    const discountPercentage = Number(discountItem?.discount_percentage || 0);

    switch (discountSource) {
      case "prod_discount":
        return `Product Discount${
          discountPercentage > 0 ? ` (${discountPercentage}% OFF)` : ""
        }`;

      case "cat_discount":
        return `Category Discount${
          discountPercentage > 0 ? ` (${discountPercentage}% OFF)` : ""
        }`;

      case "global_discount":
        return `Flat Discount${
          discountPercentage > 0 ? ` (${discountPercentage}% OFF)` : ""
        }`;

      default:
        return null;
    }
  };

  const address = useSelector((state) => state.order.orderAddress);
  useEffect(() => {
    dispatch(getSingleOrderAddress({ id: selectedAddressId }));
  }, [dispatch, selectedAddressId]);

  //order place
  const [razorid, setRazorId] = useState();
  const [Razorpay] = useRazorpay();
  const handleRazorpay = async (price) => {
    const amountInPaise = Math.round(price * 100);
    const options = {
      key: "rzp_test_I05KCFb1v5JJRc",
      amount: amountInPaise,
      currency: "INR",
      name: "Sri Jaya Jewellery ",
      description: "Test Transaction",
      image:
        "http://localhost:3000/static/media/hippicart-logo.427718645d3015dbf003.png",

      handler: async (res) => {
        await setRazorId(res.razorpay_payment_id);
        finalFunction(res.razorpay_payment_id);
      },
      prefill: {
        name: "Piyush Garg",
        email: "youremail@example.com",
        contact: "9999999999",
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#052c65",
      },
    };

    const rzpay = new Razorpay(options);
    rzpay.open();
  };

  const finalFunction = async (razorpay) => {
    setLoader(true);
    const datafinal = {
      exchange_rate_id: currentCurrency?.id,
      exchange_rate: currentCurrency?.rate,
      address_id: selectedAddressId,
      payment_method_id: paymentValue,
      order_summary: data?.order_summary,
      order_Details_summary: data?.order_Details_summary,
    };
    if (razorpay) {
      datafinal.payment_id = razorpay;
    }

    const res = await dispatch(createOrder(datafinal));

    if (res.meta?.requestStatus === "fulfilled") {
      if (res?.payload?.data?.actionUrl && res?.payload?.data?.paymentData) {
        const form = document.createElement("form");
        form.method = "POST";
        form.action = res?.payload?.data?.actionUrl;

        const paymentData = res.payload?.data.paymentData;

        Object.keys(paymentData).forEach((key) => {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = key;
          input.value = paymentData[key];
          form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit();
      } else {
        handleClick();
      }

      await dispatch(getAllCart(isSignin));
    } else if (res.meta?.requestStatus === "rejected") {
      setErrors(res.payload);
      // if (res.payload?.errors?.email) {
      //     setError("email", {
      //       type: "manual",
      //       message: res.payload?.errors?.email,
      //     });
      //   }
    }
    setLoader(false);
  };

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const onSubmit = async (couponData) => {
    const res = await dispatch(CouponApplyed(couponData));

    if (res?.payload?.data) {
      setCouponData(res.payload.data);
    }

    if (res?.payload?.errors) {
      setError("code", {
        type: "manual",
        message: res.payload.errors,
      });
    }

    return res;
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [deleteData, setDeleteData] = useState({
    id: null,
    product_id: null,
    variant_id: null,
  });

  const openDeleteModal = (id, product_id, variant_id) => {
    setDeleteData({
      id,
      product_id,
      variant_id,
    });

    setShowDeleteModal(true);
  };

  const handleDelete = async () => {
    await deleteCart(
      deleteData.id,
      deleteData.product_id,
      deleteData.variant_id,
    );

    setShowDeleteModal(false);
  };

  const deleteCart = async (id, product_id, varient_id) => {
    const res = await dispatch(
      deleteAllCart({ id, isSignin, product_id, varient_id }),
    );
    if (res.meta?.requestStatus === "fulfilled") {
      // await dispatch(getAllCart(isSignin));
      // await orderCalculation(selectedAddressId);

      const cartRes = await dispatch(getAllCart(isSignin));

      const updatedCart = cartRes.payload?.data || [];

      if (updatedCart.length === 0) {
        setData({});
        setErrors(null);
      } else {
        await orderCalculation(selectedAddressId, currentCurrency);
      }
    } else if (res.meta?.requestStatus === "rejected") {
      console.log("Error:", res.payload || "Not In Cart");
    }
  };

  useEffect(() => {
    if (!allcartData?.data?.length) {
      setData({});
      setErrors(null);
      navigate("/product-cart");
    }
  }, [allcartData]);

  return (
    <>
      <div className={"Cart_Products_card Order_Overview"}>
        <div className="row">
          <div className="col-lg-7">
            <div className="table-responsive desktop_view">
              <Table>
                <tbody>
                  {allcartData?.data?.map((val) => (
                    <tr>
                      <td>
                        <div className="row">
                          <div className="col-sm-4 col-12">
                            <div className="img_holder">
                              <img
                                className="Product_img"
                                src={val.Product?.image}
                                alt={"Product_img"}
                              />
                            </div>
                          </div>
                          <div className="col-sm-8 col-12">
                            <div className="info_text_holder">
                              <div>
                                {/* <p className="section_title_text">
                                  Product Description
                                </p> */}

                                <h4>{val.Product?.name}</h4>

                                {(() => {
                                  const appliedDiscount = getAppliedDiscount(
                                    val,
                                  );

                                  const badgeText = getDiscountBadgeText(
                                    appliedDiscount,
                                  );

                                  if (!badgeText) {
                                    return null;
                                  }

                                  const discountAmount = Number(
                                    appliedDiscount?.offer_discount || 0,
                                  );

                                  const discountPercentage = Number(
                                    appliedDiscount?.discount_percentage || 0,
                                  );

                                  return (
                                    <div className="offer_discount_badge">
                                      <span>{badgeText}</span>

                                      {discountAmount > 0 && (
                                        <small>
                                          {" "}
                                          • Saved {symbol}{" "}
                                          {(discountAmount * rate).toFixed(2)}
                                        </small>
                                      )}
                                    </div>
                                  );
                                })()}
                                <h6>
                                  {val?.Product_Variant?.name && (
                                    <p className="mb-1">
                                      <b>Polish: </b>
                                      {val?.Product_Variant?.name}
                                    </p>
                                  )}

                                  {val?.Double_Variant?.name && (
                                    <p className="mb-1">
                                      <b>Colour: </b>
                                      {val?.Double_Variant?.name}
                                    </p>
                                  )}

                                  {val?.Triple_Variant?.name && (
                                    <p className="mb-1">
                                      <b>Size: </b>
                                      {val?.Triple_Variant?.name}
                                    </p>
                                  )}
                                </h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>

                      <td>
                        <div className="Quantity_tr_holder">
                          <div className="new_price_holder">
                            {/* <p className="price_inner_text">
                              <span className="right_label">Price : </span>
                              {symbol}{" "}
                              {(
                                Number(
                                  val.t_variant_id
                                    ? val.Triple_Variant?.price
                                    : val.d_variant_id
                                    ? val.Double_Variant?.price
                                    : val.Product_Variant?.price,
                                ) *
                                rate *
                                Number(val.quantity)
                              ).toFixed(2)}
                            </p> */}

                            {(() => {
                              const appliedDiscount = getAppliedDiscount(val);

                              const totalAmount =
                                Number(
                                  val.t_variant_id
                                    ? val.Triple_Variant?.price
                                    : val.d_variant_id
                                    ? val.Double_Variant?.price
                                    : val.Product_Variant?.price,
                                ) *
                                rate *
                                Number(val.quantity || 0);

                              const discountAmount =
                                Number(appliedDiscount?.offer_discount || 0) *
                                rate;

                              const payableAmount = Math.max(
                                0,
                                totalAmount - discountAmount,
                              );

                              return (
                                <p className="price_inner_text">
                                  {discountAmount > 0 ? (
                                    <>
                                      <span
                                        style={{
                                          textDecoration: "line-through",
                                          marginBottom: "2px",
                                          fontWeight: "400",
                                        }}
                                      >
                                        {symbol} {totalAmount.toFixed(2)}
                                      </span>

                                      <span
                                        style={{
                                          marginBottom: "0",
                                          marginLeft: "10px",
                                        }}
                                      >
                                        {symbol} {payableAmount.toFixed(2)}
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      {symbol} {totalAmount.toFixed(2)}
                                    </>
                                  )}
                                </p>
                              );
                            })()}

                            {/* <p className="price_inner_text">
                              <span className="right_label">MRP : </span>
                              {symbol}{" "}
                              {(
                                Number(
                                  val.t_variant_id
                                    ? val.Triple_Variant?.mrp
                                    : val.d_variant_id
                                    ? val.Double_Variant?.mrp
                                    : val.Product_Variant?.mrp,
                                ) *
                                rate *
                                Number(val.quantity || 0)
                              ).toFixed(2)}
                            </p> */}

                            <p className="price_inner_text">
                              {" "}
                              <span className="right_label">
                                Product Qty :{" "}
                              </span>{" "}
                              {val?.quantity}{" "}
                            </p>
                          </div>
                        </div>
                        <div className="d-flex justify-content-end">
                          <div
                            className="mobile_delete_div"
                            // onClick={() =>
                            //   deleteCart(
                            //     val?.id,
                            //     val?.product_id,
                            //     val?.variant_id,
                            //   )
                            // }
                            onClick={() =>
                              openDeleteModal(
                                val?.id,
                                val?.product_id,
                                val?.variant_id ||
                                  val?.d_variant_id ||
                                  val?.t_variant_id,
                              )
                            }
                          >
                            <span className="inner_text">Remove</span>
                            <FontAwesomeIcon
                              className="trash_icon"
                              icon={faTrashCan}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

            <div className="mobile_view">
              {allcartData?.data?.map((val) => (
                <div className="box_div">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="row ">
                        <div className="col-sm-5 col-5">
                          <div className="img_holder">
                            <img
                              className="Product_img"
                              src={val.Product?.image}
                              alt={"Product_img"}
                            />
                          </div>
                        </div>
                        <div className="col-sm-7 col-7">
                          <div className="info_text_holder">
                            <div>
                              <h4>{val.Product?.name}</h4>

                              {(() => {
                                const appliedDiscount = getAppliedDiscount(val);

                                const badgeText = getDiscountBadgeText(
                                  appliedDiscount,
                                );

                                if (!badgeText) {
                                  return null;
                                }

                                const discountAmount = Number(
                                  appliedDiscount?.offer_discount || 0,
                                );

                                const discountPercentage = Number(
                                  appliedDiscount?.discount_percentage || 0,
                                );

                                return (
                                  <div className="offer_discount_badge">
                                    <span>{badgeText}</span>

                                    {discountAmount > 0 && (
                                      <small>
                                        {" "}
                                        • Saved {symbol}{" "}
                                        {(discountAmount * rate).toFixed(2)}
                                      </small>
                                    )}
                                  </div>
                                );
                              })()}
                              {/* <p className="sale_price">
                                Sale Price: {symbol}
                                {Number(
                                  Number(
                                    val.Triple_Variant?.price ||
                                      val.Double_Variant?.price ||
                                      val.Product_Variant?.price,
                                  ) * rate,
                                ).toFixed(2)}{" "}
                              </p> */}
                              <h6>
                                {val?.Product_Variant?.name && (
                                  <p className="mb-1">
                                    <strong>Polish : </strong>{" "}
                                    {val?.Product_Variant?.name}
                                  </p>
                                )}

                                {val?.Double_Variant?.name && (
                                  <p className="mb-1">
                                    <strong>Colour : </strong>{" "}
                                    {val?.Double_Variant?.name}
                                  </p>
                                )}

                                {val?.Triple_Variant?.name && (
                                  <p className="mb-1">
                                    <strong>Size : </strong>{" "}
                                    {val?.Triple_Variant?.name}
                                  </p>
                                )}
                                <div className="price_holder">
                                  <p className="mb-0">Qty: {val?.quantity} </p>
                                </div>
                                <div className="price_holder">
                                  {/* <p className="mb-0">
                                    {symbol}{" "}
                                    {(
                                      Number(
                                        val.Product_Variant?.price ||
                                          val.Double_Variant?.price ||
                                          val.Triple_Variant?.price,
                                      ) *
                                      rate *
                                      Number(val.quantity)
                                    ).toFixed(2)}
                                  </p> */}

                                  <p className="mb-0">
                                    {(() => {
                                      const appliedDiscount = getAppliedDiscount(
                                        val,
                                      );

                                      const totalAmount =
                                        Number(
                                          val.Product_Variant?.price ||
                                            val.Double_Variant?.price ||
                                            val.Triple_Variant?.price ||
                                            0,
                                        ) *
                                        rate *
                                        Number(val.quantity || 0);

                                      const discountAmount =
                                        Number(
                                          appliedDiscount?.offer_discount || 0,
                                        ) * rate;

                                      const payableAmount = Math.max(
                                        0,
                                        totalAmount - discountAmount,
                                      );

                                      return discountAmount > 0 ? (
                                        <>
                                          <span
                                            style={{
                                              textDecoration: "line-through",
                                              marginBottom: "2px",
                                              fontWeight: "400",
                                            }}
                                          >
                                            {symbol} {totalAmount.toFixed(2)}
                                          </span>

                                          <p
                                            style={{
                                              marginBottom: "0",
                                              marginLeft: "10px",
                                              display: "inline-block",
                                            }}
                                          >
                                            {symbol} {payableAmount.toFixed(2)}
                                          </p>
                                        </>
                                      ) : (
                                        <>
                                          {symbol} {totalAmount.toFixed(2)}
                                        </>
                                      );
                                    })()}
                                  </p>
                                  <br />
                                </div>
                              </h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-12">
                      <div className="Quantity_tr_holder"></div>

                      <div className="Quantity_tr_holder">
                        <div
                          className="mobile_delete_div"
                          // onClick={() =>
                          //   deleteCart(
                          //     val?.id,
                          //     val?.product_id,
                          //     val?.variant_id,
                          //   )
                          // }
                          onClick={() =>
                            openDeleteModal(
                              val?.id,
                              val?.product_id,
                              val?.variant_id ||
                                val?.d_variant_id ||
                                val?.t_variant_id,
                            )
                          }
                        >
                          <span className="inner_text">Remove</span>
                          <FontAwesomeIcon
                            className="trash_icon"
                            icon={faTrashCan}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="col-lg-5">
            {allcartData?.data?.length > 0 && (
              <div className="Rewards_text_holder">
                <h4>Offers and Rewards</h4>
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <InputGroup className="mb-3">
                    <InputGroup.Text
                      className="tags_icon_holder"
                      id="basic-addon2"
                    >
                      {" "}
                      <FontAwesomeIcon className="tags_icon" icon={faTags} />
                    </InputGroup.Text>

                    <Form.Control
                      className="mb-0"
                      readOnly
                      placeholder="Select Coupon Code"
                      {...register("code", {
                        required: "Coupon code is required",
                      })}
                      // readOnly={!!CouponData}
                    />

                    {CouponData ? (
                      // If coupon code exists, View acts as submit
                      <InputGroup.Text
                        as="button"
                        type="submit"
                        className="view_grp"
                        id="basic-addon2"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setCouponData("");
                          setValue("code", "");
                          setCouponError("");
                        }}
                      >
                        Remove
                      </InputGroup.Text>
                    ) : (
                      // If no code, open modal
                      <InputGroup.Text
                        className="view_grp"
                        id="basic-addon2"
                        onClick={() => {
                          setCouponError("");
                          setShowCouponModal(true);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        View Coupon
                      </InputGroup.Text>
                    )}
                    {/* <InputGroup.Text
                  className="view_grp"
                  id="basic-addon2"
                  onClick={() => {
                    setShowCouponModal(true);
                  }}
                >
                  View
                </InputGroup.Text> */}
                  </InputGroup>
                  {couponError && (
                    <div className="text-danger fw-bold mt-1">
                      {couponError}
                    </div>
                  )}
                </Form>
              </div>
            )}

            {allcartData?.data?.length > 0 && (
              <Order_Overview_summery_holder
                data={data}
                address={address}
                paymentValue={paymentValue}
              />
            )}
            {Errors && <div className="alert alert-danger mt-2">{Errors}</div>}

            {loader ? (
              <>
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </>
            ) : (
              <>
                <div className="btn_holder back_next_btn d-flex justify-content-center">
                  <Green_Outline_Btn btnText={"Back"} onClick={prev} />
                  {allcartData?.data?.length > 0 ? (
                    <Green_Outline_Btn
                      btnText={"Place Order"}
                      onClick={() =>
                        paymentValue !== 2
                          ? finalFunction()
                          : // : handleRazorpay(data?.order_summary?.total_amount)
                            finalFunction()
                      }
                      disabled={!!Errors}
                    />
                  ) : (
                    <Green_Outline_Btn
                      btnText={"Continue Shopping"}
                      onClick={() => navigate("/shops")}
                    />
                    // <Link to="/shops" className="btn btn-outline-success">
                    //   Continue Shopping
                    // </Link>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <Success_Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        successText="Your Order Has Been Placed Successfully!"
      />

      <Coupons_Modal
        setValue={setValue}
        setCouponData={setCouponData}
        setCouponError={setCouponError}
        onSubmit={onSubmit}
        data={data}
        show={showCouponModal}
        onHide={() => {
          setShowCouponModal(false);
        }}
      />

      <Delete_Modal
        show={modalDeleteShow}
        onHide={() => setModalDeleteShow(false)}
        successText="Order Deleted Sucessfuly"
      />

      {/* Delete Modal */}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
        className="Cancel_Reason_Modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Remove Product</Modal.Title>
        </Modal.Header>

        <Modal.Body>Are you sure you want to remove this product?</Modal.Body>

        <Modal.Footer>
          <div className="btns_holder">
            <Green_btn
              btnText={"Cancel"}
              onClick={() => setShowDeleteModal(false)}
            />

            <Orange_Btn btnText={"Delete"} onClick={handleDelete} />
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default Order_Overview;
